import { tv } from 'tailwind-variants';
import baseStyles from './Base.styles';

const styles = tv({
  extend: baseStyles,
  slots: {
    input: `
      data-[state=checked]:border-green-600
      data-[state=checked]:bg-green-100
    `,
  },
});

export default styles;
